import React from 'react';
import { SectionLayout } from '@/components/shared/section-layout';

export function LeadsPage() {
  return (
    <SectionLayout title="Leads" />
  );
} 